import React from "react";
import {EXCEL_UTIL} from "../../../../common/util/excel/excel.util";
import {UploadType} from "../../../../common/enums/ExcelEnum";
import {Box} from "@material-ui/core";
import EduContentStepDaySelection from "../control/EduContentStepDaySelection";
import {DIALOG_TYPES} from "../../../../common/enums/DialogTypes";
import {inject, observer} from "mobx-react";

function StepDaySelectionContent (props) {
const {stepValue, dayValue, setStepValue, setDayValue,isUploadReady} = props.excelStore;

    const uploadFileAction = async (file) => {
        if (file) {
            await EXCEL_UTIL.uploadExcelFileByStepAndDay(file,UploadType.PART,stepValue,dayValue,checkSelectedStepAndDay);
        }
    }

    const checkSelectedStepAndDay = (result) => {
        props.excelStore.requestToCheckForExistingContents(result,EXCEL_UTIL.getSheetInfo(),actionAfterCheckingStepAndDayForExistingContent);
    }

    const actionAfterCheckingStepAndDayForExistingContent = (bool,content,list) => {
        if (bool)  {
            openAskToContinueDialog(content,list);
        } else  {
            requestUploadContent(content,list);
        }
    }

    const openAskToContinueDialog = (content,list) => {
        props.dialogStore.openNewDialog({
            titleText:'',
            text:'이미 등록된 데이터가 있습니다. 덮어 쓰시겠습니까?',
            controlBtn:true,
            clickButton: () => requestUploadContent(content,list),
            controlBtnText:'확인',
            additionalActionOnClose:()=>EXCEL_UTIL.initExcelData()
        });
    }

    const requestUploadContent = (content,list) => {
        props.excelStore.manageToRequest(content,list);
        openContentUploadDialog();
    }

    const openContentUploadDialog = () => {
        props.dialogStore.openNewDialog({
            titleText: "컨텐츠 업로드",
            contentType: DIALOG_TYPES.EXCEL_UPLOAD_ALL,
            additionalActionOnClose:initExcelRelatedData
        });
    }

    const initExcelRelatedData = () => {
        props.excelStore.initExcelUploadRelated();
    }


    return (
        <Box display='flex' alignItems='center'>
            <input id={'excelUpload'} style={{ display: 'none' }} accept={".xlsx, .xls"}  onChange={(e) => uploadFileAction(e.target.files[0])} placeholder={'전체 파일'} type={'file'}/>
            {!isUploadReady &&
                <EduContentStepDaySelection
                    stepValue = {stepValue}
                    dayValue = {dayValue}
                    setStepValue = {setStepValue}
                    setDayValue = {setDayValue}
                />
            }
        </Box>
    )
}
export default
inject('excelStore','contentStore','dialogStore')(
    observer(StepDaySelectionContent)
);
